import WarningIcon from '@mui/icons-material/Warning';
import { i18n } from 'i18n';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { BackfillWarningDto } from 'providers/api';

const PREFIX = 'WarningTooltipIcon';

const classes = {
  warningIcon: `${PREFIX}-warningIcon`,
};

const StyledTooltip = styled(Tooltip)((
  {
    theme,
  },
) => ({
  [`& .${classes.warningIcon}`]: {
    color: theme.palette.warning.main,
    fontSize: '1.1rem',
  },
}));

interface WarningTooltipIconProps {
  warnings: BackfillWarningDto[];
}

const WarningTooltipIcon = ({ warnings }: WarningTooltipIconProps) => (
  <StyledTooltip
    title={(
      <List>
        {
          warnings.map((warning: BackfillWarningDto) => (
            <ListItem key={(Math.random() + 1).toString(36).substring(7)}>
              {i18n._(warning.display ?? '')}
            </ListItem>
          ))
        }
      </List>
    )}
  >
    <WarningIcon className={classes.warningIcon} />
  </StyledTooltip>
);

export default WarningTooltipIcon;
